module.exports = __webpack_public_path__ + "img/image-with-text.ff100ccd.webp";